module.exports = __webpack_public_path__ + "img/maximize-field.361ecc90.svg";